/**
 *To compare if the first date is before or after the second date, or they are same date.
 *@param oneDate, Object, first date
 *@param anotherDate, Object, second dates
 *@param oneDateSum, Integer, integer sum of year*10000, month*100 and date, of first date
 *@param anotherDateSum, Integer, integer sum of year*10000, month*100 and date, of second date
 *@return {Integer} if less than 0, first date is before, if equals 0, they are same date, else first date is after
 *
 */

const YEAR_MULTIPLIER = 10000;
const MONTH_MULTIPLIER = 100;

const ERROR_MESSAGE = 'Argument(s) Are Invalid';
const dateComparator = (oneDate, anotherDate) => {
  try {
    const oneDateSum =
      oneDate.getFullYear() * YEAR_MULTIPLIER + oneDate.getMonth() * MONTH_MULTIPLIER + oneDate.getDate();
    const anotherDateSum =
      anotherDate.getFullYear() * YEAR_MULTIPLIER + anotherDate.getMonth() * MONTH_MULTIPLIER + anotherDate.getDate();

    return oneDateSum - anotherDateSum;
  } catch (err) {
    return ERROR_MESSAGE;
  }
};

export default dateComparator;
